import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import _get from 'lodash/get';
import useSiteCopySelector from 'components/useSiteCopySelector';
import { toSentenceCase } from 'utils/stringUtils';
// eslint-disable-next-line import/no-cycle
import CustomEmailResultsModal from './CustomEmailResultsModal';

const useStyles = makeStyles(theme => ({
  emailButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.text.tertiary,
    borderRadius: '32px',
    padding: '16px 32px',
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.bgColor.default,
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: '100%',
      marginTop: 16,
      minWidth: 225,
    },
  },
}));

const CustomEmailResultsButton = ({ onEmailSent, assessment, ...props }) => {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const [assessmentResultsSiteCopy] = useSiteCopySelector([
    'assessment-results',
  ]);

  const emailButtonText = _get(
    assessmentResultsSiteCopy,
    'pageCopy.emailResultsLabel',
    '',
  );

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleEmailSubmit = email => {
    if (onEmailSent) {
      onEmailSent(email);
    }
  };

  return (
    <>
      <Button
        className={classes.emailButton}
        onClick={handleOpenModal}
        {...props}
      >
        {toSentenceCase(emailButtonText)}
      </Button>

      <CustomEmailResultsModal
        open={modalOpen}
        onClose={handleCloseModal}
        onEmailSent={handleEmailSubmit}
        assessment={props.assessment}
      />
    </>
  );
};

export default CustomEmailResultsButton;
